import styled, { css } from 'styled-components';
import SVG from 'react-inlinesvg';

export default styled(SVG)`
  ${({ themed, theme, active, type, backgroundShade }) =>
    themed &&
    css`
      path {
        fill: ${active ? theme.colors[type].color : theme.colors.gray.color};
      }

      rect {
        fill: ${active
          ? theme.colors[type].shades[backgroundShade]
          : theme.colors.gray.shades[backgroundShade]};
      }

      g {
        g {
          fill: ${active ? theme.colors[type].color : theme.colors.gray.color};
        }

        path {
          fill: ${active ? theme.colors[type].color : theme.colors.gray.color};
        }

        rect {
          fill: ${active
            ? theme.colors[type].shades[backgroundShade]
            : theme.colors.gray.shades[backgroundShade]};
        }

        g > g {
          g {
            fill: ${active
              ? theme.colors[type].color
              : theme.colors.gray.color};
          }

          path {
            fill: ${active
              ? theme.colors[type].color
              : theme.colors.gray.color};
          }

          rect {
            fill: ${active
              ? theme.colors[type].shades[backgroundShade]
              : theme.colors.gray.shades[backgroundShade]};
          }
        }
      }
    `}
`;
